<template>
  <div>
    <v-card elevation="0">
      <div class="my-4 mx-3">
        <div ><h4>{{ $t('meter.select_meter') }}</h4></div>
        <v-autocomplete
          :items="meters"
          :item-text="meterName"
          :item-value="d => d"
          @change="changeMeter"
          full-width 
          solo
          hide-details
        />

      </div>
      <Bar
        :chart-options="chartData.options"
        :chart-data="chartData.data"
        chart-id="myChart3"
        dataset-id-key="label"
        :height="150"
      />
      <v-snackbar v-model="isError" color="error" top>
        <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
      </v-snackbar>
    </v-card>
	</div>
</template>
<script>
import { mapState } from "vuex";
import Layout from "@/components/Layout.vue";
import { DigitalMeterReport , Meter } from "../classes"
import meterReport from "../json/meterData.json"
import { Bar } from 'vue-chartjs/legacy'
export default {
  props: {
    selectedMonthYear: Object
  },
	components: {
		Layout,
    Bar
	},
  data() {
    return {
			projectId: this.$route.params.projectId,
			isLoading: false,
			isError: false,
      project: null,
      markets: null,
      meter: null,
      chartData: {
        data: {
          labels: [],
          datasets: []
        },
        options: {}
      }
    }
  },
  computed: {
    ...mapState({
      sessionAdmins: (state) => state.admin.sessionAdmins,
      meters: (state) => state.meter.meters,
      meterReports: (state) => state.digitalMeterReport.meterReports,
    }),
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
  mounted(){
    this.initData()
  },
	methods: {
    prepareData(){
      if(this.meter && this.meterReports){
        this.chartData.data.labels = []
        this.chartData.data.datasets = []

        let mm = this.$moment({month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year})
        let data = []

        for(let i = 1; i <= mm.daysInMonth(); i++){
          let now = this.$moment({ days: i, month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year })
          let previous = this.$moment({ days: i, month: this.selectedMonthYear.month - 1, year: this.selectedMonthYear.year }).subtract(1, "days")
          

          let _now = this.$moment(now).format("YYYY-MM-DD")
          let _previous = this.$moment(previous).format("YYYY-MM-DD")

          for(let _meterReport of this.meterReports){
            if(_meterReport.filter(d => d.cust_id == this.meter.digitalMeterData.cust_id)){
              let report = _meterReport.filter(d => d.cust_id == this.meter.digitalMeterData.cust_id)

              let previousRecord = report.reverse().find(d => d.tb_date == _previous)
              let nowRecord = report.reverse().find(d => d.tb_date == _now)

              let meter_id = this.meter.digitalMeterData.meter_id
              if(nowRecord){
                let unit =  parseFloat(nowRecord["tb_kWh" + meter_id])
                let previousUnit = previousRecord && previousRecord["tb_kWh" + meter_id] ? parseFloat(previousRecord["tb_kWh" + meter_id]) : 0

                if(!data[i - 1]) data[i - 1] = 0
                data[i - 1] += parseFloat((unit - previousUnit).toFixed(2))
              }
            }
          }
          this.chartData.data.labels.push(now.format("D/M/YY"))
        }

        this.chartData.data.datasets = [
          {
            label: `${this.meter.area.name} ${this.meter.isMain ? this.$t('main') : this.meter.name}`,
            data: data,
            backgroundColor: "rgba(3, 208, 44, .7)",
          }
        ]

        this.chartData.options = {
          responsive: true,
          scales: {
            x: {
              title: {
                display: true,
                text: this.$t('date')
              },
            },
            y: {
              title: {
                display: true,
                text: this.$t('unit')
              },
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: (context) => {
                  if(context.parsed.y)
                    return `${context.dataset.label} ${context.parsed.y} ${this.$t('unit')}`
                }
              }
            }
          }
        }

      }

    },
		async initData(){
			this.isLoading = true
			try {
        if(this.admins){
          this.project = this.admins[0].project
          this.markets = this.admins.map(d => d.market)
        }
        this.prepareData()
				this.isLoading = false
			} catch(error) {
        console.log(error)
				this.isLoading = false
				this.isError = true
			}
		},
    changeMeter(meter){
      this.meter = meter
      this.prepareData(meter)
    },
    meterName(meter){
      return `${meter.market.name} , ${meter.area.name} , ${meter.isMain ? this.$t('main') : meter.name}`
    }
	}
}
</script>
